<div>
  <p>Signing data...</p>
</div>
 <footer-submit-cancel #footer (submit)="onSubmit ()"  (cancel)="onCancel ()"></footer-submit-cancel>